import { AlertTriangle } from "lucide-react";
import React from "react";

/** Плашка `warnings` ответа: картинка неполная, и молча показанная неполная
 *  картинка выглядит как полная. Компактная, но не сворачивается и не
 *  исчезает сама. Пустой список — плашки нет. */
export function DashboardWarnings({ warnings }: { warnings: string[] }): React.ReactElement | null {
  if (warnings.length === 0) return null;
  return (
    <div
      role="alert"
      className="flex gap-2 rounded-md border border-amber-300 bg-amber-50 px-2.5 py-1.5 text-xs leading-5 text-amber-900"
    >
      <AlertTriangle className="mt-0.5 size-3.5 shrink-0" />
      <div className="min-w-0">
        <span className="font-medium">Картинка неполная:</span>
        <ul className="list-disc pl-4">
          {warnings.map((w) => (
            <li key={w} className="break-words">
              {w}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
